<template lang="pug">
	.available-courses-container
		top-bar(
			:state='topbarState'
			:scroll-top='scrollTop'
			@update-topbar='updateTopbar'
		)

		CoursesList(
			@scroll-topbar='scrollTopbar'
			:view="''"
			:courses='savedCourses'
		)

		mobile-filters
</template>

<script>
import TopBar from '@/components/TopBar';
import CoursesList from '@/components/CoursesList';
import MobileFilters from '@/components/MobileFilters';

export default {
  name       : 'saved-courses',
  components : {
    TopBar,
    CoursesList,
    MobileFilters
  },

  data : () => ( {
    topbarState : '',
    scrollTop   : 0,
  } ),

  computed : {
    searchResults() {
      return this.$store.getters.searchResults;
    },

    savedCourses() {
      let courses = this.$store.getters.savedCourses;
      // Only include courses that appeared in the search results
      if ( this.searchResults ) courses = courses.filter( c1 => this.searchResults.find( c2 => c1.id === c2.id ) );
      else courses = this.$store.getters.appliedFilters( courses );
      return courses.sort( ( c1, c2 ) => ( c1.name > c2.name ? 1 : -1 ) );
    }
  },

  methods : {
    scrollTopbar( e ) {
      const { scrollTop } = e.target;
      const deltaY    = ( this.scrollTop - scrollTop );
      this.scrollTop = scrollTop;

      if ( this.topbarState === 'search' ) {
        return;
      }
      if ( scrollTop < 165 ) {
        this.topbarState = '';
        return;
      }
      if ( deltaY < 0 ) {
        this.topbarState = 'collapsed';
      }
      else {
        this.topbarState = '';
      }
    },

    updateTopbar( state ) {
      this.topbarState = state;
    }
  },
};
</script>

<style lang="scss" scoped>
	.available-courses-container {
		height: 100vh;
		display: flex;
		flex-direction: column;
		background: white;
	}
</style>
